export default __webpack_public_path__ + "static/media/IMG_4990-min.b60242fd.JPG";